import { statusPill } from "@/lib/format";

export function PageHeader({
  eyebrow,
  title,
  action,
}: {
  eyebrow: string;
  title: string;
  action?: React.ReactNode;
}) {
  return (
    <header className="rise mb-8 flex items-end justify-between gap-6">
      <div>
        <div className="eyebrow mb-2" style={{ color: "var(--c-ink-soft)" }}>
          {eyebrow}
        </div>
        <h1 className="display text-[40px]">{title}</h1>
      </div>
      {action}
    </header>
  );
}

export function StatusPill({ status }: { status?: string | null }) {
  if (!status) return null;
  return <span className={statusPill(status)}>{String(status).replaceAll("_", " ")}</span>;
}

export function Stat({
  label,
  value,
  sub,
  tone = "light",
}: {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  tone?: "light" | "dark" | "green" | "cream";
}) {
  const cls =
    tone === "dark" ? "card-dark" : tone === "green" ? "card-green" : tone === "cream" ? "card-cream" : "card";
  return (
    <div className={`${cls} p-6`}>
      <div
        className="eyebrow mb-3"
        style={{ color: tone === "dark" ? "var(--c-on-dark-soft)" : "var(--c-ink-soft)" }}
      >
        {label}
      </div>
      <div className="display text-[34px]">{value}</div>
      {sub ? (
        <div
          className="mt-2 text-[13px] font-light"
          style={{ color: tone === "dark" ? "var(--c-on-dark-soft)" : "var(--c-ink-soft)" }}
        >
          {sub}
        </div>
      ) : null}
    </div>
  );
}

export function Empty({ title, hint, action }: { title: string; hint?: string; action?: React.ReactNode }) {
  return (
    <div className="card-cream flex flex-col items-start gap-3 p-8">
      <div className="display text-[24px]">{title}</div>
      {hint ? (
        <p className="max-w-md text-[15px] font-light" style={{ color: "var(--c-ink-soft)" }}>
          {hint}
        </p>
      ) : null}
      {action}
    </div>
  );
}
